import FormGroup from 'components/shared/FormGroup';
import Select from 'components/shared/Select';
import { Controller, useFormContext } from 'react-hook-form';
import { FormSelectProps } from './FormSelect.types';

export const FormSelect: React.FC<FormSelectProps> = ({
  name,
  options,
  formGroup = {},
  input = {}
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <FormGroup
      {...formGroup}
      error={errors?.[name]?.message?.toString()}
      forId={name}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            id={name}
            options={options}
            type="text"
            variant={errors?.[name] ? 'error' : ''}
            {...input}
            {...field}
            value={field.value || ''}
          />
        )}
      />
    </FormGroup>
  );
};
